module.exports = __webpack_public_path__ + "img/video-icon.348c6fae.svg";